import { useDispatch } from 'react-redux';
import Text, {
  TEXT_COLOR,
  TEXT_KIND,
  TEXT_FONT_WEIGHT,
  TEXT_SIZE,
  TEXT_DISPLAY,
} from '@/bit/components/components.text';
import dynamic from 'next/dynamic';
import CustomLink from '@/bit/components/components.custom-link';
import { actions as modalActions } from '@/bit/reducers/reducers.modals-reducer';
import {
  OPACITY_LAYOUT_COLORS,
  CONTENT_POSITION,
  IN_SCENE_EFFECT,
  OUT_SCENE_EFFECT,
} from '@/bit/components/components.modal';
import { DEVICE_KIND } from '@/constants/constant';
import getDeviceKindDependsOnViewPort from '@gcloud-npm/utils.common.get-device-kind-depends-on-viewport';
import CheckboxController from '@/components/checkboxController';

function LegalTerms({
  name,
  id,
  control,
  rules,
  label,
  buttonText,
  className,
  legalTerms,
  cyData,
}) {
  const dispatch = useDispatch();
  const handelModalLegalConditions = () => {
    const deviceKind = getDeviceKindDependsOnViewPort();
    const ModalLegalConditions = dynamic(() =>
      import('@/modals/termsAndConditions')
    );
    dispatch(
      modalActions.addModal({
        createAnchor: false,
        type: 'MODAL',
        id: 'ModalLegalConditionsCS',
        Element2Show: ModalLegalConditions,
        elementProps: {
          legalTerms,
        },
        modalProps: {
          opacityLayoutColor: OPACITY_LAYOUT_COLORS.BLACK05,
          contentPosition:
            deviceKind === DEVICE_KIND.MOBILE
              ? CONTENT_POSITION.CENTER_BOTTOM
              : CONTENT_POSITION.RIGHT_CENTER,
          inSceneEffect:
            deviceKind === DEVICE_KIND.MOBILE
              ? IN_SCENE_EFFECT.FADE_IN_BOTTOM
              : IN_SCENE_EFFECT.FADE_IN_RIGHT,
          outSceneEffect:
            deviceKind === DEVICE_KIND.MOBILE
              ? OUT_SCENE_EFFECT.FADE_OUT_BOTTOM
              : OUT_SCENE_EFFECT.FADE_OUT_RIGHT,
          closeByClickingOutside: true,
          contentInsideContainer: false,
        },
      })
    );
  };

  return (
    <CheckboxController
      inputName={name}
      inputId={id}
      control={control}
      rules={rules}
      className={className}
    >
      <>
        <Text
          text={`${label}&nbsp;`}
          color={TEXT_COLOR.GREY6}
          kind={TEXT_KIND.PARAGRAPH}
          size={TEXT_SIZE.CAPTION2}
          display={TEXT_DISPLAY.INLINE}
          fontType={TEXT_FONT_WEIGHT.REGULAR}
        />
        <CustomLink
          className="legal-terms-link"
          role="button"
          onClick={handelModalLegalConditions}
          taggingInfo={{
            componentVariation: 'all',
            componentContent: buttonText,
            componentProduct: '',
            componentName: 'link',
          }}
          cyData={`${cyData}__link`}
        >
          <Text
            text={buttonText}
            kind={TEXT_KIND.PARAGRAPH}
            color={TEXT_COLOR.BLUEA}
            display={TEXT_DISPLAY.INLINE}
            size={TEXT_SIZE.CAPTION2}
            fontType={TEXT_FONT_WEIGHT.REGULAR}
            cyData={`${cyData}__link-text`}
          />
        </CustomLink>
      </>
      <style jsx>
        {`
          :global(.legal-terms-link) {
            display: contents;
          }
        `}
      </style>
    </CheckboxController>
  );
}

export default LegalTerms;
